import { Box, Spacer, Text } from "@chakra-ui/react";
import { PaymentButton } from "../PaymentSection";
import { Pricing } from "./Pricing";

export function UnlimitedPricingCard() {
  return (
    <Pricing.Card>
      <Pricing.ProductType>Unlimited Pack</Pricing.ProductType>
      <Pricing.Price>$49.99</Pricing.Price>
      <Box mt="lg">
        <PaymentButton productId="unlimited" />
      </Box>
      <Pricing.CardNumber>Unlimited Premium Cardolies!</Pricing.CardNumber>

      <Text color="gray.500" textAlign={"center"} mb="md">
        You can create as many Premium Cardolies as you want!
      </Text>

      <Pricing.FeatureList
        features={[
          "Unlimited Premium Cardolies (saves you a lot of money!)",
          "Unlimited posts",
          "Use multiple fonts",
          "Custom font colors",
          "Add messages and GIFs",
          "Many backgrounds",
          "Desktop & mobile friendly",
          "Accessible forever",
          "No advertisements",
          "Deliver online",
        ]}
      />
      <Text textAlign="center" mt="md" fontWeight={"bold"}>
        Valid for 1 year
      </Text>
      <Spacer />
      {/* 
      <Pricing.Footer>
        <PaymentButton productId="unlimited" />
      </Pricing.Footer> */}
    </Pricing.Card>
  );
}
